import React, {useState, useEffect, useRef} from 'react';
import {Modal, Steps, Button, message, Checkbox, Input, Table} from 'antd'
import {calculator, subTaskSettleInfo} from '../../../api/TaskSettlement'
import {importsExcel} from "../../../until/excel";
import TaskSettlementConfirm from './TaskSettlementConfirm'
import './TaskSettlementImport.less'
import {caretTrimReplace} from "semver/internal/re";

const TaskSettlementImport = (props) => {
    const [upFlag, setUpflag] = useState(true)
    const [dataMsg, setDataMsg] = useState([])
    const [fileName, setFileName] = useState('')
    const [fileType, setFileType] = useState(false)
    const [isConfirmVisible, setIsConfirmVisible] = useState(false)
    const [excelPersonNum, setExcelPersonNum] = useState(0)
    const [excelTotalAmount, setexcelTotalAmount] = useState(0)
    const [calcularTitleVisibility, setCalcularTitleVisibility] = useState(true)
    const [recharge, setRecharge] = useState(0)
    const [amountAfter, setAmountAfter] = useState(0)
    const [totalFee, setTotalFee] = useState(0)
    const [amountBefore, setAmountBefore] = useState(0)
    const [file, setFile] = useState([])
    const myRef = useRef()
    let {visible, onOk, onCancel, onFinish} = props
    const handleOk = () => {
        setExcelPersonNum(dataMsg.length)
        let totalAmount = 0
        dataMsg.forEach(item => {
            if (item.paymentAmount) {
                totalAmount += Number(item.paymentAmount)
            }
        })
        setexcelTotalAmount(totalAmount)
        onUpFan()
    }
    const handleCancel = () => {
        setIsConfirmVisible(false)
    }
    const onUpFan = () => {
        if (dataMsg.length) {
            let merchantServeId = window.localStorage.getItem("merchantServeId");
            let param = new FormData()
            param.append('merchantServeId', merchantServeId)
            param.append('totalAmount', excelTotalAmount)
            param.append('taskSettlementInfoStr', JSON.stringify(dataMsg))
            param.append('taskName', fileName)
            param.append("file", file[0])
            subTaskSettleInfo(param).then(res => {
                if (res.data.code === 200) {
                    message.success('导入成功');
                    onFinish()
                    onCancel()
                } else {
                    message.error(res.data.message);
                    setFileType(true)
                    setDataMsg(res.data.data.failList)
                }
            })
        } else {
            message.warn("请上传有效文件")
        }
        setIsConfirmVisible(false)
        setUpflag(true)
    }
    const calculatorAmount = (arrListJson) => {
        setCalcularTitleVisibility(false)
        let param = new FormData()
        let merchantServeId = window.localStorage.getItem("merchantServeId");
        param.append('merchantServeId', merchantServeId)
        param.append('totalAmount', excelTotalAmount)
        param.append('taskSettlementInfoStr', JSON.stringify(arrListJson))
        param.append('taskName', fileName)
        calculator(param).then((res) => {
            if (res.data.code === 200) {
                let totalAmount = 0
                let afterAmount = 0
                let totalFee = 0
                res.data.data.list.forEach((item, index) => {
                    totalAmount += Number(item.detail_price)
                    //税后金额
                    afterAmount += Number(item.actual_money)

                    totalFee += Number(item.fee)

                    arrListJson[index]['taxAfterAmount'] = Number(item.actual_money)
                    arrListJson[index]['personSystemFee'] = Number(item.person_system_fee)
                    arrListJson[index]['personAddedTax'] = Number(item.person_added_tax)
                })

                setAmountBefore(totalAmount)
                setAmountAfter(afterAmount)
                setTotalFee(totalFee)
                setRecharge(totalAmount + totalFee)

                setDataMsg(arrListJson)
            }
        })
    }
    const handleExcel = (e) => {
        setFileType(false)
        if (e.target.value) {
            setFileName(e.target.files[0].name)
            importsExcel(e).then(
                function (data) {
                    if (data && data.length >= 3) {
                        setExcelPersonNum(data[0]["累计笔数"])
                        setexcelTotalAmount(data[0]["累计应发"])

                        let arr = []
                        for (let i = 2; i < data.length; i++) {
                            data[i]["key"] = i - 1

                            //姓名
                            if (data[i]["累计应发"] != null) {
                                data[i]["累计应发"] = data[i]["累计应发"].toString().trim();
                            }
                            //身份证号
                            if (data[i]["累计笔数"] != null) {
                                data[i]["累计笔数"] = data[i]["累计笔数"].toString().trim();
                            }
                            //手机号
                            if (data[i]["__EMPTY"] != null) {
                                data[i]["__EMPTY"] = data[i]["__EMPTY"].toString().trim();
                            }
                            //银行卡号
                            if (data[i]["__EMPTY_1"] != null) {
                                data[i]["__EMPTY_1"] = data[i]["__EMPTY_1"].toString().trim();
                            }
                            //金额
                            if (data[i]["__EMPTY_2"] != null) {
                                data[i]["__EMPTY_2"] = data[i]["__EMPTY_2"].toString().trim();
                            }
                            //备注
                            if (data[i]["__EMPTY_3"] != null) {
                                data[i]["__EMPTY_3"] = data[i]["__EMPTY_3"].toString().trim();
                            }

                            arr.push(data[i])
                        }
                        for (let i = 0; i < arr.length; i++) {
                            if (arr[i]["累计应发"] && arr[i]["__EMPTY_1"]
                                && idcardNumberReg.test(arr[i]["累计笔数"]) && phoneNumberReg.test(arr[i]["__EMPTY"])
                            ) {
                                setUpflag(false)
                                setFile(e.target.files)
                            } else {
                                setUpflag(true)
                            }
                        }

                        arr.forEach((item, index) => {
                            // 创建新的对象，将汉字key转换为英文key
                            const newItem = {
                                key: item.key,
                                name: item['累计应发'] || '',
                                idcardNumber: item['累计笔数'] || '',
                                phoneNumber: item['__EMPTY'] || '',
                                receiveAccount: item['__EMPTY_1'] || '',
                                paymentAmount: item['__EMPTY_2'] || '',
                                payRemark: item['__EMPTY_3'] || ''
                            };
                            // 替换原数组中的项
                            arr[index] = newItem;
                        })

                        setDataMsg(arr);

                        const merchantType = window.localStorage.getItem("merchantType");
                        if (merchantType === "lingtu") {
                            calculatorAmount(arr);
                        }
                    }
                },
            )
        }
    }
    var phoneNumberReg = /^1\d{10}$/
    var idcardNumberReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    const columns = [
        {
            title: '序号',
            dataIndex: 'key',
            render: (text, record) =>
                (record.zipCode && record.name && record.receiveAccount && record.paymentChannel
                    && record.idcardType
                    && record.idcardNumber && record.phoneNumber && record.paymentAmount && phoneNumberReg.test(record.phoneNumber) && idcardNumberReg.test(record.idcardNumber)) ? (
                    <span>{text}</span>) : (<span style={{color: "red"}}>{text}</span>)
        },
        {
            title: '姓名',
            dataIndex: 'name'
        },
        {
            title: '身份证号码',
            dataIndex: 'idcardNumber'
        },
        {
            title: '手机号码',
            dataIndex: 'phoneNumber'
        },
        {
            title: '账号',
            dataIndex: 'receiveAccount'
        },
        {
            title: '税前金额',
            dataIndex: 'paymentAmount'
        },
        {
            title: '税后金额',
            dataIndex: 'taxAfterAmount'
        },
        {
            title: '个人增值税',
            dataIndex: 'personAddedTax'
        },
        {
            title: '个人所得税',
            dataIndex: 'personSystemFee'
        },
        {
            title: '备注',
            dataIndex: 'payRemark'
        },
    ];
    const failColumns = [
        {
            title: '编码',
            dataIndex: 'key'
        },
        {
            title: '姓名',
            dataIndex: 'name'
        },
        {
            title: '身份证号码',
            dataIndex: 'idcardNumber'
        },
        {
            title: '手机号码',
            dataIndex: 'phoneNumber'
        },
        {
            title: '账号',
            dataIndex: 'receiveAccount'
        },
        {
            title: '税前金额',
            dataIndex: 'paymentAmount'
        },
        {
            title: '备注',
            dataIndex: 'payRemark'
        },
        {
            title: '失败原因',
            dataIndex: 'remark',
            render: remark => {
                return (
                    <span style={{color: 'red'}}>{remark}</span>
                )
            }
        }
    ];
    return (
        <Modal title="任务结算导入" visible={visible} onOk={onOk} onCancel={onCancel} width={1500} footer={null}>
            <div style={{color: '#e6a23c'}}>
                <div>提示：</div>
                <div>1、导入数据需要跟模板格式一样方可导入</div>
                <div>2、单个批次模板数据不能超过500条</div>
                <div>3、如果有未签约的数据，请先人才签约后再上传。</div>
            </div>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px',
                marginBottom: '10px'
            }} hidden={calcularTitleVisibility}>
                <div style={{display: 'flex', alignItems: 'center', marginRight: '120px'}}>
                    <div style={{textAlign: 'center'}}>
                        <div style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#f67932',
                            marginBottom: '5px'
                        }}>{recharge || 0}</div>
                        <div style={{fontSize: '14px'}}>需打款总额</div>
                    </div>
                    <div style={{fontSize: '24px', fontWeight: 'bold', color: '#f67932', margin: '0 20px'}}>=</div>
                    <div style={{textAlign: 'center'}}>
                        <div style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#f67932',
                            marginBottom: '5px'
                        }}>{amountBefore || 0}
                        </div>
                        <div style={{fontSize: '14px'}}>税前总金额</div>
                    </div>
                    <div style={{fontSize: '24px', fontWeight: 'bold', color: '#f67932', margin: '0 20px'}}>+</div>
                    <div style={{textAlign: 'center'}}>
                        <div style={{fontSize: '20px', fontWeight: 'bold', color: '#f67932', marginBottom: '5px'}}>{totalFee || 0}
                        </div>
                        <div style={{fontSize: '14px'}}>服务费总额</div>
                    </div>
                </div>
                <div style={{textAlign: 'center', marginRight: '60px'}}>
                    <div style={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                        color: '#f67932',
                        marginBottom: '5px'
                    }}>{amountAfter || 0}
                    </div>
                    <div style={{fontSize: '14px'}}>税后总金额</div>
                </div>
                <div style={{textAlign: 'center'}}>
                    <div style={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                        color: '#f67932',
                        marginBottom: '5px'
                    }}>{excelPersonNum || 0}</div>
                    <div style={{fontSize: '14px'}}>人次</div>
                </div>
            </div>
            <div style={{marginTop: '20px'}}>
                <div>
                    <Input ref={myRef} type="file" accept=".xls,.xlsx" onChange={handleExcel}
                           style={{width: 200, marginRight: 10}}></Input>
                    <Button type="primary" disabled={upFlag} onClick={onUpFan}>确定无误后，上传此表格数据</Button>
                </div>
                <Table columns={fileType ? failColumns : columns} dataSource={dataMsg}/>
            </div>
            {
                isConfirmVisible ? (
                    <TaskSettlementConfirm visible={isConfirmVisible} onOk={handleOk} onCancel={handleCancel}
                                           excelPersonNum={excelPersonNum} excelTotalAmount={excelTotalAmount}/>) : ""
            }
        </Modal>
    )
}
export default TaskSettlementImport
